import Vue from 'vue'

import vuePortailPackage from 'vue-portail-package';

vuePortailPackage.install();

Vue.config.productionTip = false
const image = require('./assets/logo.png');

new Vue({
    router: vuePortailPackage.router,
    store: vuePortailPackage.store,
    i18n: vuePortailPackage.i18n,
    vuetify: vuePortailPackage.vuetify,
    render: h => h(vuePortailPackage.App),
    created() {
        this.$store.dispatch('theme/applyTheme', {
            image,
            primaryColor: '#0B8288',
            fontPrimaryColor: '#FFFFFF',
            secondaryColor: '#17292A',
        });
        this.$store.commit('theme/setImage', image)
    },
}).$mount('#app')
